import { CaseReducer, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { BookResponseModel } from 'data/library/book/book.model';

type SliceState = {
  status: 'idle' | 'loading' | 'data' | 'error';
  data: BookResponseModel[];
  error: any;
};

const initState: SliceState = {
  status: 'idle',
  data: [],
  error: false,
};

const setLoading = (): SliceState => ({ ...initState, status: 'loading' });

const setData: CaseReducer<SliceState, PayloadAction<BookResponseModel[]>> = (_, action) => ({
  error: false,
  data: action.payload,
  status: 'data',
});

const setError: CaseReducer<SliceState, PayloadAction<any>> = (state, action) => ({
  error: action.payload,
  data: [],
  status: 'error',
});

const bookSlice = createSlice({
  name: 'book',
  initialState: initState,
  reducers: {
    setLoading,
    setData,
    setError,
  },
});

export default bookSlice;
